import AppRoutes from '@/const/routes';
import { RoleType } from '@/interfaces';
import { signOut } from 'next-auth/react';

export const signOutLawyer = async () => {
	await signOut({
		redirect: true,
		callbackUrl: AppRoutes.LAWYERAPP_AUTH_SIGN_IN,
		basePath: '/api/auth-lawyer',
	} as any);

	// const callback = AppRoutes.LAWYERAPP_AUTH_SIGN_IN;
	// window.location.href = `/api/auth-lawyer/signout?callbackUrl=${encodeURIComponent(
	// 	callback
	// )}`;
};

export const signOutFunction = async (
	type: RoleType | undefined
): Promise<void> => {
	if (type === 'lawyer') {
		signOutLawyer();
	} else {
		await signOut({
			redirect: true,
			callbackUrl: AppRoutes.CLIENTAPP_AUTH_SIGN_IN,
		});
	}
};
